import { render } from "./ShareSocial.vue?vue&type=template&id=0d34b9ba&scoped=true"
import script from "./ShareSocial.vue?vue&type=script&lang=js"
export * from "./ShareSocial.vue?vue&type=script&lang=js"

import "./ShareSocial.vue?vue&type=style&index=0&id=0d34b9ba&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0d34b9ba"

export default script